// Build timestamp baked in at build time by Vite (see `vite.config.ts`).
// Shown in the admin login modal so staff can verify which build a given
// iPad is running.
//
// Note: this is *not* what drives the auto-update mechanism — that
// compares the hashed JS bundle filename in `/index.html` against the
// running document (see `useAutoUpdate.ts`).
declare const __KIOSK_BUILD_DATE__: string

export const KIOSK_BUILD_DATE: string = __KIOSK_BUILD_DATE__
